interface ICoord {
  lat: number,
  lng: number
}

export default (coords: ICoord[]) => ({
  minLat: Math.min(...coords.map((coord: ICoord) => coord.lat)),
  minLng: Math.min(...coords.map((coord: ICoord) => coord.lng)),
  maxLat: Math.max(...coords.map((coord: ICoord) => coord.lat)),
  maxLng: Math.max(...coords.map((coord: ICoord) => coord.lng)),
})
